/**
 * v-safe-html：v-html 的净化版本。
 *
 * 用法与 v-html 完全一致（`<div v-safe-html="content" />`），区别是写入 DOM 前先过
 * `@/utils/sanitizeHtml` 的 DOMPurify 白名单过滤。《代码安全开发规范》第 1.2 节要求
 * 富文本展示侧必须净化，凡是渲染后端下发内容的地方都应改用本指令，
 * 避免每个组件各自 import 一遍净化函数、漏掉一处就是一个 XSS 入口。
 *
 * 仅用于「展示」外部内容。contenteditable 这类由用户实时编辑的节点不要用它——
 * 每次更新重写 innerHTML 会打断输入法与光标，那类场景应在取值侧用 readSafeText。
 */
import { sanitizeHtmlString } from '@/utils/sanitizeHtml'

const render = (el, value) => {
  el.innerHTML = sanitizeHtmlString(value)
}

export default function registerSafeHtml(app) {
  app.directive('safe-html', {
    mounted(el, binding) {
      render(el, binding.value)
    },
    updated(el, binding) {
      // 值没变就不重写 DOM，避免无谓的重复解析
      if (binding.value !== binding.oldValue) render(el, binding.value)
    }
  })
}
